// extracted by mini-css-extract-plugin
module.exports = {"container":"DurationModal_container__2M6L7","description":"DurationModal_description__3HLM_","button":"DurationModal_button__CL8Cp"};